import React from 'react';
import { faEnvelope, faLocationDot, faPhone } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './RootOrganization.module.scss';
import { formatPhoneNumber } from '@spike/phone-utils';

interface RootOrganizationProps {
    orgName: string;
    orgType: string;
    orgAddress: string;
    orgPhone: string;
    orgEmail: string;
}

const RootOrganization: React.FC<RootOrganizationProps> = ({ orgName, orgType, orgAddress, orgPhone, orgEmail }) => {
    return (
        <div className={styles.rootOrganization}>
            <div className={styles.organizationName}>
                <label>{orgName}</label>
                <p>{orgType}</p>
            </div>
            <div className={styles.organizationInfo}>
                <div className={styles.infoSection}>
                    <FontAwesomeIcon icon={faLocationDot} />
                    <p>{orgAddress}</p>
                </div>
                <div className={styles.infoSection}>
                    <FontAwesomeIcon icon={faPhone} />
                    <p>{formatPhoneNumber(orgPhone, 'US')}</p>
                </div>
                <div className={styles.infoSection}>
                    <FontAwesomeIcon icon={faEnvelope} />
                    <p>{orgEmail}</p>
                </div>
            </div>
        </div>
    );
};

export default RootOrganization;
